import { getUser } from "../userStore";
import { OPTIMAL_CARE_ID, ETHIZO_PRACTICE_ID, BELLY_HEALTH_PRACTICE_ID } from "./practiceIds";

export const ALLOW_DOWNLOAD_VISIT = [OPTIMAL_CARE_ID];

export const policyBookByLocation = () => {
    const user = getUser();

    const allowedPracticeIds = [
        BELLY_HEALTH_PRACTICE_ID, // ORA2, Belly Health
        ETHIZO_PRACTICE_ID, // For testing purpose, ETHIZO
    ];

    if (allowedPracticeIds.includes(user?.practice_id)) {
        return true;
    }
    
    return false;
}